import React from "react";
import { Backdrop, CircularProgress } from "@material-ui/core";

function SpinnerCustomized(props) {
  return (
    <Backdrop
      style={{ color: "#232A56", zIndex: "1000"}}
      open={true}
    >
      <CircularProgress color="#232f66" />
    </Backdrop>
  );
}

export default SpinnerCustomized;
